<template>
    <div class="main-block request-management">
        <Breadcrumbs />
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.Users') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0  " style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">

                    <template slot>
                        <router-link :to="{ name: 'AddUsers', params: { operation: 'add' } }" class="btn btn-primary">
                            <b-icon icon="plus" class="icon-style"></b-icon>
                            {{ $t('title.addnew') }}
                        </router-link>
                    </template>

                    <template #cell(actions)="{ item }">
                        <b-button variant="Primary" v-b-tooltip.hover title="Delete"  @click="openModal">
                            <b-icon variant="danger" icon="trash" class="icon-style"></b-icon>
                        </b-button>
                        <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel"
                            aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteModalLabel">{{
                                            $t('title.confirmDeleteUsers') }}
                                        </h5>
                                    </div>
                                    <div class="modal-body">
                                        {{ $t('title.confirmDeletionUsers') }}

                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" @click="closeModal"> {{
                                            $t('title.cancel') }}</button>
                                        <button type="button" class="btn btn-danger" @click="deleteItem(item.id)">
                                            {{
                                                $t('title.yes') }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <b-button variant="Primary" v-b-tooltip.hover title="Edit" 
                            @click="$router.push({ name: 'UpdateUsers', params: { id: item.id, operation: 'edit' } })">
                            <b-icon variant="primary" icon="pencil-square" class="icon-style"></b-icon>
                        </b-button>
              
                    </template>

                    <template #cell(is_active)="{ item }">
                        <b-button variant="Primary" @click="toggleStatus(item.id, item.is_active)">
                            <b-icon :variant="item.is_active ? 'success' : 'secondary'" :icon="item.is_active ? 'toggle-on' : 'toggle-off'" class="icon-style"></b-icon>
                        </b-button>
                    </template>

                </crud-table>
            </div>
        </div>
    </div>

</template>

<script>
import {
    request
} from "@/Util/Request";
import {
    mapState
} from "vuex";
import {
    Modal
} from "bootstrap";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

const FILTER_FORM = {
    roles: null,
    statuses: null
};

const COLUMN_STATE = (self) => [{
    key: 'actions',
    label: self.$t('title.actions')
},
{
    key: 'email',
    label: self.$t('title.email')
},
{
    key: 'full_name',
    label: self.$t('title.full_name'),
    sortable: true
},
{
    key: 'phone',
    label: self.$t('title.phone'),
    sortable: true
},
{
    key: 'roles',
    label: self.$t('title.role'),
    sortable: true
},
{
    key: 'is_active',
    label: self.$t('title.status'),
    sortable: true
},

];

export default {
    data() {
        return {
            operation: '',
            query: {
                page: 1,
                perPage: 10,
            },
            pagination: {
                total: 0, // total rows
            },
            listUrl: '/admin/system-users',
            filters: {
                ...FILTER_FORM
            },
            showPopup: false,
            modalInstance: null,

        };
    },
    components: { Breadcrumbs },
    methods: {

        openModal() {
            const modalElement = document.getElementById("deleteModal");
            this.modalInstance = new Modal(modalElement); // Initialize modal
            this.modalInstance.show();
        },
        closeModal() {
            if (this.modalInstance) {
                this.modalInstance.hide();
            }
        },

        async deleteItem(id) {
            try {
                const response = await request({
                    method: 'delete',
                    url: `/admin/system-users/${id}`,
                });

                if (this.modalInstance) {
                    this.modalInstance.hide();
                    this.showToast(
                        this.$t("title.usersDeleted"),
                        this.$t("title.usersDeletedSuccess")
                    );

                }
                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                this.notifyError();
            }
        },
        async toggleStatus(id, is_active) {
            try {
                const response = await request({

                    method: 'get',
                    url: `/admin/system-users/change-status/${id}`,
                });

                this.showToast(
                    is_active == 1
                        ? this.$t("title.usersDeactivated")
                        : this.$t("title.usersActivated"),
                    is_active == 1
                        ? this.$t("title.usersDeactivatedSuccess")
                        : this.$t("title.usersActivatedSuccess"),
                    is_active == 1 ? null : 1
                );
                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                this.notifyError();
            }
        },
        handleFilter() {
            this.$refs['application-table'].handleFilter(this.filters);
        },
        resetFilter() {
            this.filters = {
                ...FILTER_FORM
            };
        },
        showToast(title, msg, status) {
            const h = this.$createElement;
            const vNodesMsg = h('p', {
                class: ['text-center', 'mb-0']
            }, [msg]);
            const vNodesTitle = h('div', {
                class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2']
            },
                [h('strong', {
                    class: 'mr-2'
                }, title)]
            );

            this.$bvToast.toast([vNodesMsg], {
                title: [vNodesTitle],
                solid: true,
                variant: status === 1 ? 'primary' : 'danger',
            });
        }

    },
    computed: {
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
